import { render, staticRenderFns } from "./RegistryEntry.vue?vue&type=template&id=0547a9c5&"
import script from "./RegistryEntry.vue?vue&type=script&lang=js&"
export * from "./RegistryEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports